import { startAcmeInsuranceRenewalMondayTriggerStreamLoop } from './acmeInsuranceRenewalMondayTriggerStreamLoop.js'
import { updatePendingAcmeInsuranceRenewalDemoMessage } from './patchAcmeInsuranceRenewalDemoMessage.js'

/** @param {import('./runB2bCopilotPlanDemoStream.js').B2bStreamCtx} ctx */
export function runAcmeInsuranceRenewalMondayTriggerStream(ctx) {
  updatePendingAcmeInsuranceRenewalDemoMessage(ctx.setMessagesByThreadId, ctx.tid, ctx.pendingId, {
    demoStreamActive: true,
  })
  startAcmeInsuranceRenewalMondayTriggerStreamLoop(ctx)
}
